export default __webpack_public_path__ + "static/media/66.e79fd4c7.jpeg";